/** 
 * @module: 任务详情页UI
 * @author: yuanxm
 * @date: 2020-05-19 18:50:09
 */

import { observable } from 'mobx';

class TaskDetailUI {
  // 评论弹窗
  @observable commentDrawer: boolean = false;
  // 关联项目弹窗
  @observable projectDrawer: boolean = false;
  // 单独修改项目看板的看板弹窗
  @observable standaloneKanbanDrawer: boolean = false;
  // 关联目标弹窗
  @observable targetDrawer: boolean = false;
  // 选择目标弹窗
  @observable tagDrawer: boolean = false;
  // 奖励积分弹窗
  @observable awardDrawer: boolean = false;
  // 修改描述
  @observable editDescDrawer: boolean = false;
  // 设置目标值
  @observable expectValueDrawer: boolean = false;
  // 设置实际值
  @observable targetValueDrawer: boolean = false;
  // 参与者弹窗
  @observable followerDrawer: boolean = false;
  // 验收人弹窗
  @observable acceptorDrawer: boolean = false;
  // 验收任务
  @observable checkTaskDrawer: boolean = false;
  // 任务类型弹窗
  @observable taskCategoryDrawer: boolean = false;
  // 添加任务清单弹窗
  @observable ckaddDrawer: boolean = false;

  // 缺陷类型
  @observable defectTypeDrawer: boolean = false;
  // 缺陷严重程度
  @observable deepTypeDrawer: boolean = false;
  // 缺陷复现概率
  @observable probabilityTypeDrawer: boolean = false;

  // 需求类型
  @observable featureTypeDrawer: boolean = false;

  // 风险类型
  @observable riskTypeDrawer: boolean = false;

  // 验收任务时 通过还是退回 1通过 0退回
  @observable isTaskPass: 0 | 1 = 1;

  // 任务详情页是否正在编辑标题
  @observable editSub: boolean = false;

  constructor() {}
}

export default TaskDetailUI;
